import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
} from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  addAccount,
  convertAccount,
  editAccountName,
  getAccountDetails,
  updateAccount,
} from '../../../network/ChartAccount';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getSearchApiAcount } from '../../../network/itemList';
import { DownOutlined } from '@ant-design/icons';
import { IoPieChart } from 'react-icons/io5';
import HeadingApp from '../../../hooks/HeadingApp';
// import { getSearchApi } from '../../../network/itemList';
const ChartAccountAdd = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const client = useQueryClient();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [loadingAddAccount, setLoadingAddAccount] = useState(false);
  const { id } = useParams();
  const [newName, setNewName] = useState(id ? id : null);
  const [searchTxt, setSearchTxt] = useState('');
  const { message } = App.useApp();
  const watchIsGroup = Form.useWatch('is_group', form);
  const { currentLang, companyName } = useSelector((state) => state.user);
  const { mutate: onAddAccount } = useMutation({
    mutationKey: ['addAccount'],
    mutationFn: (body) => (edit ? updateAccount(body, id) : addAccount(body)),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      // client.invalidateQueries({ queryKey: [ services ? queryKeys.getServices : queryKeys.getItems] });
      client.invalidateQueries({ queryKey: [queryKeys.getAccounts] });
      form.resetFields();
      navigate('/accounts');
    },
    onError: (error) => {
      setLoadingAdd(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onEditAccountName } = useMutation({
    mutationKey: ['editAccountName'],
    mutationFn: (body) => editAccountName(body),
    onSuccess: (data) => {
      setLoadingAddAccount(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setNewName(data?.message);
      message.success('Record successfully updated!');
      setOpen(false);
      // client.invalidateQueries({ queryKey: [ services ? queryKeys.getServices : queryKeys.getItems] });
      client.invalidateQueries({
        queryKey: [queryKeys.getAccountDetails, newName],
      });
    },
    onError: (error) => {
      setLoadingAddAccount(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { data: accountDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getAccountDetails, newName],
    queryFn: () => getAccountDetails(newName),
    keepPreviousData: true,
    enabled: !!edit && !!newName,
  });
  const { mutate: onConvertAccount } = useMutation({
    mutationKey: ['convertAccount'],
    mutationFn: () =>
      convertAccount({
        isGroup: watchIsGroup,
        docs: accountDetails?.data,
      }),
    onSuccess: (data) => {
      setLoadingAddAccount(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success('Record successfully updated!');
      // client.invalidateQueries({ queryKey: [ services ? queryKeys.getServices : queryKeys.getItems] });
      client.invalidateQueries({
        queryKey: [queryKeys.getAccountDetails, newName],
      });
    },
    onError: (error) => {
      setLoadingAddAccount(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const watchAccountType = Form.useWatch('account_type', form);

  // const { data: accounts } = useQuery({
  //   queryKey: [queryKeys.getAccounts],
  //   queryFn: () => getAccounts(),
  //   keepPreviousData: true,
  // });
  const { data: account } = useQuery({
    queryKey: [queryKeys.getSearchApiAccount, searchTxt],
    queryFn: () =>
      getSearchApiAcount({
        type: 'Account',
        searchTxt: searchTxt,
        is_group: 1,
      }),
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
    keepPreviousData: true,
  });

  // const { data: ParentAccount } = useQuery({
  //   queryKey: [queryKeys.getChartAccountParent],
  //   queryFn: () => getChartAccountParent(companyName),
  //   keepPreviousData: true,
  // });
  // const filteredAccounts = accounts?.message?.accounts?.filter(
  //   (account) => account.is_group === 1
  // );
  const onFinish = (values) => {
    console.log('Success:', values);
    setLoadingAdd(true);
    onAddAccount({
      // accountData: JSON.stringify({
      //   ...values,
      //   is_group:values?.is_group ? 1 : 0,
      //   disabled:values?.disabled ? 1 : 0,
      //   company: companyName,
      // }),
      ...values,
      is_group: values?.is_group ? 1 : 0,
      disabled: values?.disabled ? 1 : 0,
      company: companyName,
    });
    // if(edit){
    //   onAddAccount({
    //     accountData: JSON.stringify({
    //       ...values,
    //       is_group:values?.is_group ? 1 : 0,
    //       disabled:values?.disabled ? 1 : 0,
    //       company: companyName,
    //       name:id
    //     }),
    //   });
    // }else{
    //   onAddAccount({
    //     accountData: JSON.stringify({
    //       ...values,
    //       is_group:values?.is_group ? 1 : 0,
    //       disabled:values?.disabled ? 1 : 0,
    //       company: companyName,
    //     }),
    //     // ...values,
    //     // is_group:values?.is_group ? 1 : 0,
    //     // disabled:values?.disabled ? 1 : 0,
    //     // company: companyName,
    //   });
    // }
  };
  useEffect(() => {
    if (edit && accountDetails) {
      {
        form.setFieldsValue({
          ...accountDetails?.data,
          account_name_up: accountDetails?.data?.account_name,
          account_number_up: accountDetails?.data?.account_number,
        });
      }
    }
  }, [accountDetails, edit, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  const itemsMenu = [
    {
      key: '1',
      label: (
        // status?.workflow_state === 'Scheduled' && (
        <Button type="text" size="small">
          {t.EditAccountDetails}
        </Button>
      ),
      onClick: () => {
        setOpen(true);
      },
    },
    {
      key: '2',
      label: (
        <Button type="text" size="small">
          {watchIsGroup ? t.groupToLedger : t.ledgerToGroup}
        </Button>
      ),
      onClick: () => {
        // console.log(accountDetails?.data);
        onConvertAccount();
      },
    },
  ];
  return (
    <div className="chart-account-add">
      {/* <Heading
        title={t.ChartAccount}
        subTitle={t.AddChartAccount}
        path="/accounts"
      /> */}
      <HeadingApp
        nameTab={t.SalesFinance}
        title={t.ChartAccount}
        subTitle={edit ? t.EditChartAccount : t.AddChartAccount}
        icon={<IoPieChart />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Flex align="center" justify="space-between">
          <h4 className="title-card">{t.titleCardAddPatient}</h4>
          {edit && (
            <Dropdown
              menu={{ items: itemsMenu }}
              trigger={['click']}
              arrow
              className="btn-light"
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
        >
          {/* <Divider orientation="left">{t.AccountInformation}</Divider> */}
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    // name="firstName"
                    name="account_name"
                    label={t.AccountName}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.AccountName} disabled={edit} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    name="account_number"
                    label={t.AccountNumber}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.AccountNumber}
                      type="number"
                      disabled={edit}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    name="parent_account"
                    label={t.ParentAccount}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    {/* <Select
                  placeholder={t.ParentAccount}
                  // onChange={(value, option) => {
                  //   console.log(option, 'option');
                  //   form.setFieldsValue({
                  //     root_type: option?.data?.root_type,
                  //     report_type: option?.data?.report_type,
                  //   });
                  // }}
                  options={ParentAccount?.message?.map((item) => ({
                    value: item?.value,
                    label: item?.value,
                  }))}
                /> */}
                    <Select
                      placeholder={t.ParentAccount}
                      style={{ width: '100%' }}
                      onSearch={(value) => {
                        setSearchTxt(value);
                      }}
                      filterOption={false}
                      showSearch
                      allowClear
                      onClear={() => {
                        setSearchTxt('');
                      }}
                      onChange={() => {
                        setSearchTxt('');
                      }}
                      options={account?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={8}
                  lg={8}
                  style={{ display: !edit ? 'none' : 'block' }}
                >
                  <Form.Item
                    name="root_type"
                    label={t.RootType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    hidden={!edit}
                  >
                    <Input placeholder={t.RootType} disabled />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={8}
                  lg={8}
                  style={{ display: !edit ? 'none' : 'block' }}
                >
                  <Form.Item
                    name="report_type"
                    label={t.ReportType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    hidden={!edit}
                  >
                    <Input placeholder={t.ReportType} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    name="account_currency"
                    label={t.currency}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={'SAR'}
                  >
                    <Select placeholder={t.currency}>
                      <Select.Option value="SAR">SAR</Select.Option>
                      <Select.Option value="USD">USD</Select.Option>
                      <Select.Option value="EUR">EUR</Select.Option>
                      <Select.Option value="GBP">GBP</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    name="account_type"
                    label={t.AccountType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select placeholder={t.AccountType}>
                      <Select.Option value="SAR">SAR</Select.Option>
                      <Select.Option value="Accumulated Depreciation">
                        {currentLang === 'en'
                          ? 'Accumulated Depreciation'
                          : 'استهلاك التراكمي'}
                      </Select.Option>
                      <Select.Option value="Asset Received But Not Billed">
                        {currentLang === 'en'
                          ? 'Asset Received But Not Billed'
                          : 'الأصول المستلمة ولكن لم يتم الفوترة'}
                      </Select.Option>
                      <Select.Option value="Bank">
                        {currentLang === 'en' ? 'Bank' : 'البنك'}
                      </Select.Option>
                      <Select.Option value="Cash">
                        {currentLang === 'en' ? 'Cash' : 'النقد'}
                      </Select.Option>
                      <Select.Option value="Chargeable">
                        {currentLang === 'en' ? 'Chargeable' : 'قابلة للشحن'}
                      </Select.Option>
                      <Select.Option value="Capital Work in Progress">
                        {currentLang === 'en'
                          ? 'Capital Work in Progress'
                          : 'عمل رأس المال قيد التقدم'}
                      </Select.Option>
                      <Select.Option value="Cost of Goods Sold">
                        {currentLang === 'en'
                          ? 'Cost of Goods Sold'
                          : 'تكلفة البضائع المباعة'}
                      </Select.Option>
                      <Select.Option value="Depreciation">
                        {currentLang === 'en' ? 'Depreciation' : 'استهلاك'}
                      </Select.Option>
                      <Select.Option value="Equity">
                        {currentLang === 'en' ? 'Equity' : 'الحقوق'}
                      </Select.Option>
                      <Select.Option value="Expense Account">
                        {currentLang === 'en'
                          ? 'Expense Account'
                          : 'حساب المصروفات'}
                      </Select.Option>
                      <Select.Option value="Expenses Included In Asset Valuation">
                        {currentLang === 'en'
                          ? 'Expenses Included In Asset Valuation'
                          : 'المصروفات المدرجة في تقييم الأصول'}
                      </Select.Option>
                      <Select.Option value="Expenses Included In Valuation">
                        {currentLang === 'en'
                          ? 'Expenses Included In Valuation'
                          : 'المصروفات المدرجة في التقييم'}
                      </Select.Option>
                      <Select.Option value="Fixed Asset">
                        {currentLang === 'en'
                          ? 'Fixed Asset'
                          : 'الأصول الثابتة'}
                      </Select.Option>
                      <Select.Option value="Income Account">
                        {currentLang === 'en' ? 'Income Account' : 'حساب الدخل'}
                      </Select.Option>
                      <Select.Option value="Payable">
                        {currentLang === 'en' ? 'Payable' : 'مستحق'}
                      </Select.Option>
                      <Select.Option value="Receivable">
                        {currentLang === 'en' ? 'Receivable' : 'قابلة للتحصيل'}
                      </Select.Option>
                      <Select.Option value="Round Off">
                        {currentLang === 'en' ? 'Round Off' : 'تقريب'}
                      </Select.Option>
                      <Select.Option value="Stock">
                        {currentLang === 'en' ? 'Stock' : 'المخزون'}
                      </Select.Option>
                      <Select.Option value="Stock Adjustment">
                        {currentLang === 'en'
                          ? 'Stock Adjustment'
                          : 'تعديل المخزون'}
                      </Select.Option>
                      <Select.Option value="Stock Received But Not Billed">
                        {currentLang === 'en'
                          ? 'Stock Received But Not Billed'
                          : 'تم تلقي المخزون ولكن لم يتم الفوترة'}
                      </Select.Option>
                      <Select.Option value="Service Received But Not Billed">
                        {currentLang === 'en'
                          ? 'Service Received But Not Billed'
                          : 'تم استلام الخدمة ولكن لم يتم الفوترة'}
                      </Select.Option>
                      <Select.Option value="Tax">
                        {currentLang === 'en' ? 'Tax' : 'الضريبة'}
                      </Select.Option>
                      <Select.Option value="Temporary">
                        {currentLang === 'en' ? 'Temporary' : 'مؤقت'}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                {watchAccountType === 'Tax' && (
                  <Col xs={24} sm={12} md={8} lg={8}>
                    <Form.Item
                      name="tax_rate"
                      label={t.rate}
                      // rules={[
                      //   {
                      //     required: true,
                      //   },
                      // ]}
                      hidden={watchAccountType !== 'Tax'}
                    >
                      <Input placeholder={t.rate} />
                    </Form.Item>
                  </Col>
                )}
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item name="freeze_account" label={t.FreezeAccount}>
                    <Select placeholder={t.FreezeAccount}>
                      <Select.Option value="No">No</Select.Option>
                      <Select.Option value="Yes">Yes</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={8}
                  lg={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="is_group"
                    label={t.GroupAccount}
                    valuePropName="checked"
                    layout="horizontal"
                    className="margin-bottom-0"
                  >
                    <Checkbox disabled={edit} />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={8}
                  lg={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="disabled"
                    label={t.disabled}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => navigate('/accounts')}
                >
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loadingAdd}
                  // block
                >
                  {edit ? t.edit + ' ' + t.Account : t.submit + ' ' + t.Account}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title="Edit Account"
      >
        <Form form={form} name="edit-account" layout="vertical">
          <Form.Item
            // name="firstName"
            name="account_name_up"
            label={t.AccountName}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder={t.AccountName} />
          </Form.Item>
          <Form.Item name="account_number_up" label={t.AccountNumber}>
            <Input placeholder={t.AccountNumber} type="number" />
          </Form.Item>
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button
              type="primary"
              loading={loadingAddAccount}
              onClick={() => {
                setLoadingAddAccount(true);
                onEditAccountName({
                  name: id,
                  account_number: form.getFieldValue('account_number_up'),
                  account_name: form.getFieldValue('account_name_up'),
                });
              }}
            >
              {t.edit}
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ChartAccountAdd;
